import Vue from "vue";
import Vuetify, { colors } from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import de from "vuetify/src/locale/de";
import en from "vuetify/src/locale/en";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  lang: {
    locales: { de, en },
    current: "de",
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#282d2f",
        secondary: "#AB8661",
        accent: "#ff5722",
        error: "#f44336",
        warning: "#ff9800",
        info: "#4caf50",
        success: "#009688",
      },
      dark: {
        primary: colors.blue.lighten3,
      },
    },
  },
});

export default vuetify;
